import { render, staticRenderFns } from "./ShowTest.vue?vue&type=template&id=5a49ca13&"
import script from "./ShowTest.vue?vue&type=script&lang=js&"
export * from "./ShowTest.vue?vue&type=script&lang=js&"
import style0 from "./ShowTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports